import {Address, QuoteAddress} from '@/store/models';
import {isObject} from 'lodash';
import {i18n} from '@/i18n';
import validateFiscalCode from '@/commons/fiscalCodeValidator';
import store from '@/store';

export default function addressValidator(address: Address | QuoteAddress): string[] {
    const errors: string[] = [];

    if (!address.firstname) {
        errors.push(i18n.t('Name').toString());
    }

    if (!address.lastname) {
        errors.push(i18n.t('Last name').toString());
    }

    if (
        address.extension_attributes !== undefined &&
        address.extension_attributes.fiscaleitalia_fiscalcode !== undefined &&
        address.extension_attributes &&
        address.extension_attributes.fiscaleitalia_fiscalcode
    ) {
        if (!validateFiscalCode(address.extension_attributes.fiscaleitalia_fiscalcode)) {
            errors.push(i18n.t('Fiscal code').toString());
        }
    } else if (store.state.options.store_code === 'it_it') {
        if (!validateFiscalCode('')) {
            errors.push(i18n.t('Fiscal code').toString());
        }
    }

    if (!address.telephone) {
        errors.push(i18n.t('Phone number').toString());
    }

    if (!address.country_id || address.country_id === '0') {
        errors.push(i18n.t('State').toString());
    }

    if (!address.street[0]) {
        errors.push(i18n.t('Street').toString());
    }

    if (!address.street[1]) {
        errors.push(i18n.t('Street number').toString());
    }

    if (!address.postcode) {
        errors.push(i18n.t('Zip code').toString());
    }

    if (!address.city) {
        errors.push(i18n.t('City').toString());
    }

    if (isObject(address.region)) {
        if (
            (!address.region_id && !address.region.region) ||
            address.region.region === '' ||
            address.region.region === '0'
        ) {
            errors.push(i18n.t('State/Region').toString());
        }
    } else if (
        (!address.region_id && !address.region) ||
        address.region === '' ||
        address.region === '0' ||
        address.region === 0
    ) {
        errors.push(i18n.t('State/Region').toString());
    }

    return errors;
}
